import { ReactNode } from 'react';
import { AzureAD } from 'react-aad-msal';
import type { IAzureADProps as IAzureAD } from 'react-aad-msal';
import { msalAuthProvider } from 'services/MsalAuthProvider';
import { store } from 'state/store';
import { EmployeeDetails } from './EmployeeDetails';

type AuthProviderProps = {
  children?: ReactNode;
  enabled?: boolean;
};

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
interface IAzureADProps extends IAzureAD {
  children?: ReactNode;
}

const AzureADFunction = AzureAD as React.FC<IAzureADProps>;

export const AuthProvider = ({
  children,
  enabled = false
}: AuthProviderProps) => {
  return enabled ? (
    <AzureADFunction provider={msalAuthProvider} reduxStore={store} forceLogin>
      <EmployeeDetails>{children}</EmployeeDetails>
    </AzureADFunction>
  ) : (
    children
  );
};
